import { isBrowser } from './utils';

/**
 * Save a value to localStorage
 * @param {string} key
 * @param {any} value
 */
export const setToLocalStorage = (key: string, value: unknown) => {
  if (!isBrowser) return;

  try {
    const serialized = JSON.stringify(value);
    window.localStorage.setItem(key, serialized);
  } catch (error) {
    console.error(`Error saving key "${key}" to localStorage:`, error);
  }
};

/**
 * Get a value from localStorage
 * @param {string} key
 * @returns {any|null}
 */
export const getFromLocalStorage = (key: string): unknown => {
  if (!isBrowser) return null;

  try {
    const value = window.localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    console.error(`Error reading key "${key}" from localStorage:`, error);
    return null;
  }
};

/**
 * Remove a key from localStorage
 * @param {string} key
 */
export const removeFromLocalStorage = (key: string) => {
  if (!isBrowser) return;
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing key "${key}" from localStorage:`, error);
  }
};
